import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { login, logout, loadUserFromStorage } from 'store/authSlice';

interface GoogleUser {
  email: string;
  name: string;
  family_name: string;
  email_verified: boolean;
  picture: string;
  sub: string;
  exp: number;
  iss: string;
  nbf: number;
}

const useGoogleAuth = () => {
  const userData: GoogleUser | null = useAppSelector((state: any) => state.auth.user);
  const authStatus = useAppSelector((state: any) => state.auth.status);
  const dispatch = useAppDispatch();

  // Load from localStorage once on startup
  useEffect(() => {
    if (authStatus === 'idle') {
      dispatch(loadUserFromStorage());
    }
  }, [authStatus, dispatch]);

  // Validate Google user token
  useEffect(() => {
    if (userData && authStatus === 'loaded') {
      try {
        const now = Math.floor(Date.now() / 1000); // current time in seconds

        const isValid =
          userData.email_verified &&
          userData.exp > now &&
          userData.iss === 'https://accounts.google.com';

        console.log(isValid, 'isValid');

        if (isValid) {
          dispatch(login(userData)); // Redundant, but safe to refresh login
        } else {
          dispatch(logout());
        }
      } catch (e) {
        dispatch(logout());
      }
    }
  }, [userData, authStatus, dispatch]);
};

export default useGoogleAuth;
